module.exports = __webpack_public_path__ + "img/r-216.751d826c.jpg";